import React, { useState } from "react";
import useMediaQuery from "../hooks/useMediaQuery";
import { SHOW_MOBILE_WARNING, MOBILE_WARNING_VERSION } from "../constants/siteConfig";

const KEY = `open-wrecks:mobile-warning:${MOBILE_WARNING_VERSION}`;
const wasDismissed = () => { try { return localStorage.getItem(KEY) === "1"; } catch { return false; } };

// A thin banner under the top bar on phone-sized screens. Dismissal is remembered on this device.
export default function MobileNotice() {
  const isPhone = useMediaQuery("(max-width: 768px)");
  const [dismissed, setDismissed] = useState(wasDismissed);

  if (!SHOW_MOBILE_WARNING || !isPhone || dismissed) return null;

  const dismiss = () => {
    setDismissed(true);
    try { localStorage.setItem(KEY, "1"); } catch {}
  };

  return (
    <div className="mobile-notice" role="status">
      <span className="mobile-notice-icon" aria-hidden="true">⚠</span>
      <p>
        <strong>Heads up:</strong> Open-Wrecks isn’t fully ready for mobile yet. Some things may look off or be
        awkward to use. A desktop or tablet gives the best experience.
      </p>
      <button type="button" className="mobile-notice-close" onClick={dismiss} aria-label="Dismiss this notice">Got it</button>
    </div>
  );
}
